import React from "react";
import { Row, Col } from "react-bootstrap";
import { WhiteBoxWrapper } from "./Login.style";

const SectionHeader = ({ children }: any) => {
  return (
    <WhiteBoxWrapper>
      <Row className="align-items-center">
        <Col xs={12}>
          <h2 className="text-center">
            <b>{children}</b>
          </h2>
        </Col>
      </Row>
    </WhiteBoxWrapper>
  );
};

export default SectionHeader;
